import React from 'react';
import './About.css';
import img1 from '../Components/Assets/About1.jpeg';
import img2 from '../Components/Assets/About2.jpeg';
import img3 from '../Components/Assets/Services.jpeg';
import { FaArrowRight } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content">
            <span className="badge">About Us</span>
            <h1>We Build Digital Experiences That Matter</h1>
            <p>
              Our team of expert consultants and developers are dedicated to delivering
              solutions that align with your unique goals and challenges. With a commitment
              to excellence and a passion for problem-solving, we empower businesses to
              thrive in the ever-evolving digital landscape.
            </p>
          </div>
        </div>
      </section>

      {/* AI-Powered Solutions */}
      <section className="section ai-section">
        <div className="container">
          <div className="section-header">
            <span className="badge">AI-Powered</span>
            <h2>Agentic AI Development</h2>
            <p>
              We build intelligent AI agents that transform how your team works — handling
              complex multi-step tasks autonomously while delivering compounding value every day.
            </p>
          </div>

          {/* Agentic AI */}
          <div className="ai-agentic">
            <div className="ai-agentic-content">
              <span className="badge">Agentic AI Development</span>
              <h3>Make Day-to-Day Tasks Effortless</h3>
              <p>
                We build AI agents that transform how your team works. From automating repetitive
                workflows to intelligent document processing, code generation, and customer
                interactions — our agentic solutions handle complex multi-step tasks autonomously,
                freeing your people to focus on high-value work.
              </p>
              <p>
                Our agents learn, adapt, and improve over time, delivering compounding value
                to your organization every single day.
              </p>
              <ul className="ai-agent-capabilities">
                <li>Automated workflow orchestration</li>
                <li>Intelligent document analysis & summarization</li>
                <li>AI-powered code generation & review</li>
                <li>Customer support & engagement agents</li>
                <li>Data pipeline automation & insights</li>
                <li>Multi-agent collaboration systems</li>
              </ul>
            </div>
            <div className="ai-agentic-models">
              <h4>Powered by AWS Bedrock</h4>
              <p>We leverage the most advanced foundation models available:</p>
              <div className="model-tags">
                <span className="model-tag">Anthropic Claude 4</span>
                <span className="model-tag">Anthropic Claude Sonnet 4</span>
                <span className="model-tag">Amazon Nova Pro</span>
                <span className="model-tag">Amazon Nova Premier</span>
                <span className="model-tag">Meta Llama 4</span>
                <span className="model-tag">Mistral Large</span>
                <span className="model-tag">Cohere Command R+</span>
                <span className="model-tag">Stability AI SDXL</span>
              </div>
              <NavLink to="/contact" className="btn btn-primary ai-cta">
                Explore AI Solutions <FaArrowRight />
              </NavLink>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section why-choose-section">
        <div className="container">
          <div className="section-header">
            <span className="badge">Why Choose 1WayDoor</span>
            <h2>Specialized Expertise That Delivers Results</h2>
            <p>
              Our founding leadership brings 20+ years of hands-on IT industry experience
              delivering mission-critical solutions for Fortune 500 enterprises across
              asset management, e-commerce, and digital advertising platforms handling
              trillions of data transactions.
            </p>
          </div>

          <div className="why-choose-grid">
            <div className="why-card why-card-featured">
              <div className="why-card-number">20+</div>
              <h3>Years of Specialized IT Leadership</h3>
              <p>
                Our directors and principal consultants have led large-scale technology
                initiatives across financial services, asset management, and high-volume
                e-commerce advertising platforms. This depth of experience in regulated,
                data-intensive industries enables us to architect and deliver solutions
                that meet the highest standards of performance, security, and compliance.
              </p>
            </div>

            <div className="why-card">
              <h3>Enterprise-Scale Data Expertise</h3>
              <p>
                We have direct experience designing and optimizing systems that process
                trillions of rows in real-time — from programmatic ad-serving platforms
                to portfolio management systems. Our team understands the unique challenges
                of high-throughput, low-latency architectures at global scale.
              </p>
              <ul className="why-tags">
                <li>Trillions of transactions</li>
                <li>Real-time processing</li>
                <li>Low-latency architecture</li>
              </ul>
            </div>

            <div className="why-card">
              <h3>Domain Specialization</h3>
              <p>
                Unlike generalist firms, we bring deep domain knowledge in asset management
                and digital commerce ecosystems. Our consultants understand industry-specific
                regulations, data governance requirements, and the technical demands of
                building systems that serve millions of end-users globally.
              </p>
              <ul className="why-tags">
                <li>Asset Management</li>
                <li>E-Commerce & Ads</li>
                <li>Financial Services</li>
              </ul>
            </div>

            <div className="why-card">
              <h3>Full-Lifecycle Delivery Capability</h3>
              <p>
                From requirements analysis and solution architecture through implementation,
                testing, and production deployment — we own the complete software delivery
                lifecycle. Our methodology combines Agile best practices with enterprise
                governance for predictable, high-quality outcomes.
              </p>
              <ul className="why-tags">
                <li>Solution Architecture</li>
                <li>Agile Delivery</li>
                <li>Production Support</li>
              </ul>
            </div>

            <div className="why-card">
              <h3>Certified Technical Excellence</h3>
              <p>
                Our team holds certifications across AWS, Azure, and modern development
                platforms. We invest continuously in emerging technologies — from cloud-native
                architectures to AI/ML — ensuring our clients receive solutions built on
                current best practices and proven patterns.
              </p>
              <ul className="why-tags">
                <li>AWS Certified</li>
                <li>Cloud Architecture</li>
                <li>AI & Machine Learning</li>
              </ul>
            </div>

            <div className="why-card">
              <h3>Proven Engagement Model</h3>
              <p>
                We operate with transparency and accountability at every stage. Our structured
                engagement model includes dedicated project managers, regular stakeholder
                reporting, defined SLAs, and clear escalation paths — the hallmarks of
                a mature, enterprise-ready consulting firm.
              </p>
              <ul className="why-tags">
                <li>Dedicated PMs</li>
                <li>SLA-Driven</li>
                <li>Stakeholder Reporting</li>
              </ul>
            </div>
          </div>

          <div className="why-bottom-stats">
            <div className="why-stat">
              <div className="why-stat-value">20+</div>
              <div className="why-stat-label">Years Industry Experience</div>
            </div>
            <div className="why-stat">
              <div className="why-stat-value">Trillions</div>
              <div className="why-stat-label">Data Rows Processed</div>
            </div>
            <div className="why-stat">
              <div className="why-stat-value">Fortune 500</div>
              <div className="why-stat-label">Enterprise Clients Served</div>
            </div>
            <div className="why-stat">
              <div className="why-stat-value">100%</div>
              <div className="why-stat-label">On-Time Delivery Rate</div>
            </div>
          </div>
        </div>
      </section>

      {/* Expertise */}
      <section className="section section-alt">
        <div className="container">
          <div className="section-header">
            <span className="badge">Expertise</span>
            <h2>Trusted Industry Expertise</h2>
            <p>
              For over 20 years, our founders have partnered with companies in highly
              regulated and specialized industries to solve their most complex business problems.
            </p>
          </div>

          <div className="expertise-grid">
            <div className="expertise-card">
              <div className="expertise-image">
                <img src={img1} alt="Cloud migration services" />
              </div>
              <div className="expertise-content">
                <h3>Cloud Migration</h3>
                <h5>Invest In The Cloud For Short and Long-Term Savings</h5>
                <p>
                  Migrating software and systems to the cloud improves scalability, security,
                  and savings. Our cloud experts carefully analyze your business case and
                  existing architecture to plan out a migration roadmap to ensure a smooth transition.
                </p>
                <ul className="expertise-tags">
                  <li>Application Discovery Services</li>
                  <li>OS & Database Migration</li>
                  <li>AWS Cloud Adoption Framework</li>
                  <li>Identity & Access Management</li>
                </ul>
              </div>
            </div>

            <div className="expertise-card expertise-card-reverse">
              <div className="expertise-content">
                <h3>Cloud-Native</h3>
                <h5>Transform and Disrupt With Cloud-Native</h5>
                <p>
                  Our AWS certified cloud application development experts take full leverage
                  of cloud-native services and approaches to design for flexibility and
                  scalability without overengineering. We build applications in event-driven,
                  highly-distributed, and serverless approaches.
                </p>
                <ul className="expertise-tags">
                  <li>Amazon Web Services</li>
                  <li>Serverless Approach</li>
                  <li>Infrastructure as Code</li>
                  <li>DevOps Services</li>
                  <li>Big Data & Analytics</li>
                </ul>
              </div>
              <div className="expertise-image">
                <img src={img2} alt="Cloud native development" />
              </div>
            </div>

            <div className="expertise-card">
              <div className="expertise-image">
                <img src={img3} alt="DevOps automation" />
              </div>
              <div className="expertise-content">
                <h3>DevOps</h3>
                <h5>Combine and Conquer</h5>
                <p>
                  Our DevOps practice automates software development processes to build,
                  test, release, and manage workloads faster and more reliably. Application
                  development and infrastructure operations teams work together towards
                  shared goals for faster time to market.
                </p>
                <ul className="expertise-tags">
                  <li>Automation</li>
                  <li>CI/CD Pipelines</li>
                  <li>Environment Management</li>
                  <li>Configuration Management</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
